"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThoriumRush = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRenderer_1 = require("../render/CardRenderer");
const PlaceMoonColonyTile_1 = require("../../moon/PlaceMoonColonyTile");
const PlaceMoonRoadTile_1 = require("../../moon/PlaceMoonRoadTile");
const PlaceMoonMineTile_1 = require("../../moon/PlaceMoonMineTile");
const Card_1 = require("../Card");
const CardRenderItem_1 = require("../render/CardRenderItem");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Units_1 = require("../../Units");
class ThoriumRush extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.THORIUM_RUSH,
            cardType: CardType_1.CardType.EVENT,
            tags: [Tags_1.Tags.MOON, Tags_1.Tags.BUILDING],
            cost: 39,
            tr: { moonColony: 1, moonMining: 1, moonLogistics: 1 },
            metadata: {
                description: 'Place 1 colony tile, 1 mine tile and 1 road tile on the Moon. ' +
                    'Raise the Colony Rate, Mining Rate and Logistic Rate 1 step.',
                cardNumber: 'M56',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.moonColony().secondaryTag(CardRenderItem_1.AltSecondaryTag.MOON_COLONY_RATE)
                        .moonMine().secondaryTag(CardRenderItem_1.AltSecondaryTag.MOON_MINING_RATE)
                        .moonRoad().secondaryTag(CardRenderItem_1.AltSecondaryTag.MOON_LOGISTICS_RATE);
                }),
            },
        });
    }
    ;
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (!super.canPlay(player))
            return false;
        const moonData = MoonExpansion_1.MoonExpansion.moonData(player.game);
        const spaces = moonData.moon.getAvailableSpacesOnLand(player);
        if (spaces.length < 2)
            return false;
        const mineSpaces = moonData.moon.getAvailableSpacesForMine(player);
        if (mineSpaces.length === 0)
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, true, false, false, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        player.game.defer(new PlaceMoonColonyTile_1.PlaceMoonColonyTile(player));
        player.game.defer(new PlaceMoonMineTile_1.PlaceMoonMineTile(player));
        player.game.defer(new PlaceMoonRoadTile_1.PlaceMoonRoadTile(player));
        return undefined;
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainProductionFromMoonTrackIncrease(this.tr) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({
            card: card,
            moonColonyRateIncrease: 1,
            moonLogisticsRateIncrease: 1,
            moonMiningRateIncrease: 1,
            bonusMegaCredits: bonusMegaCredits,
        });
    }
}
exports.ThoriumRush = ThoriumRush;
//# sourceMappingURL=ThoriumRush.js.map